import styled from "@emotion/styled";

import { fontRoboto, theme } from "shared/lib/styles";

import IconClock from "scmp-app/components/newsletter/newsletter-details/icon-clock.svg";

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  gap: 5px;
  align-items: center;

  color: #727272;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;
  font-variant-numeric: lining-nums proportional-nums;

  white-space: nowrap;
`;

export const StyledIconClock = styled(IconClock)`
  flex-shrink: 0;

  inline-size: 18px;
  block-size: 18px;

  path {
    stroke: #727272;
  }
`;

export const ReadingTimeDesktop = styled.span`
  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const ReadingTimeMobile = styled.span`
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;
